import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWindow: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconWindow"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H3V3ZM4.5 4.5V10H19.5V4.5H4.5ZM6 7.25C6 6.42157 6.67157 5.75 7.5 5.75C8.32843 5.75 9 6.42157 9 7.25C9 8.07843 8.32843 8.75 7.5 8.75C6.67157 8.75 6 8.07843 6 7.25ZM10 6.5H18V8H10V6.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconWindow;
